<template>
  <basic-container>
    <div
      class="path-container"
      style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px"
    >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>健康管理护士工作站</el-breadcrumb-item>
        <el-breadcrumb-item>线上健康管理</el-breadcrumb-item>
        <el-breadcrumb-item>消息推送</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div style="margin-bottom: 1vh; padding: 0px 0px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <!-- <el-breadcrumb-item :to="{ path: '/index' }">&lt;</el-breadcrumb-item> -->
        <i
          class="el-icon-back"
          style="font-size: 20px; font-weight: bolder"
          @click="back()"
        ></i>
      </el-breadcrumb>
    </div>

    <el-button-group>
      <el-button
        class="healthButton"
        @click="click(0)"
        >健康动态数据
      </el-button>
      <el-button
        class="healthButton"
        @click="click(1)"
        >数字档案完成度
      </el-button>
      <el-button
        class="healthButton"
        @click="click(2)"
        >健康管理方案</el-button
      >
      <el-button
        class="healthButton"
        @click="click(3)"
        >认知行为治疗状态</el-button
      >
      <el-button
        class="healthButton healthActive"
        @click="click(4)"
        >消息推送</el-button
      >
    </el-button-group>
    <div class="card-row" style="margin-bottom: 20px">
      <div class="card card01">
        <div
          class="card-row"
          style="font-size: 20px; font-weight: bold; margin-bottom: 2vh"
        >
          {{ info.name }}
        </div>
        <div class="card03" style="font-size: 14px">
          <div>
            性别：{{ info.sex === 1 ? "男" : info.sex === 2 ? "女" : "未填写" }}
          </div>
          <div>手机号码：{{ info.mobile }}</div>
        </div>
        <div class="card03" style="font-size: 14px">
          <div>年龄|生日：{{ info.age }}岁 / 未填写</div>
          <div>
            身高|体重：{{ info.height ? info.height : " " }}cm/{{
              info.weight ? info.weight : " "
            }}kg
          </div>
          <div>身份证号：{{ info.idCard }}</div>
        </div>
      </div>
    </div>

    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :permission="permissionList"
      :page.sync="page"
      @on-load="onLoad"
       :header-cell-class-name="headerCellClassName"
    >
      <template slot="menuLeft"> </template>
      <template slot-scope="scope" slot="menu">
        <el-button type="text" size="small" @click="archiveType(scope.row)">
          档案信息
        </el-button>
        <!-- <el-button type="text" size="small" @click="datashow(scope.row)">
          动态数据展示
        </el-button> -->
        <el-button type="text" size="small" @click="datashow(scope.row)">
          动态数据达标
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getMessagePush, getUserJkDetail } from "@/api/health/manage";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      wxUserid: this.$route.query.wxUserId,
      info: {},
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      headerCellClassName: 'headerClass',
      option: {
        tip: false,
        border: true,
        // index: true,
        viewBtn: true,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        menu: false,
        // selection: true,
        column: [
          // {
          //   label: '生活方式',
          //   prop: 'name',
          //   dicData: [
          //     { label: '饮水', value: 0 },
          //     { label: '久坐', value: 1 },
          //     { label: '饮食打卡', value: 2 },
          //     { label: '运动打卡', value: 3 }
          //   ]
          //   // search: true
          // },
          // {
          //   label: '健康管理',
          //   prop: 'heartRate',
          //   dicData: [
          //     { label: '校准提醒', value: 0 },
          //     { label: '数字档案完善', value: 1 },
          //     { label: '服药提醒', value: 2 },
          //     { label: '每周健康状态查看', value: 3 }
          //   ]
          //   // search: true
          // }
          {
            label: "饮水提醒",
            prop: "drink",
            dicData: [
              { label: "未开启", value: 0 },
              { label: "已开启", value: 1 },
            ],
          },
          {
            label: "久坐提醒",
            prop: "sit",
            dicData: [
              { label: "未开启", value: 0 },
              { label: "已开启", value: 1 },
            ],
          },
          {
            label: "饮食打卡",
            prop: "eat",
            dicData: [
              { label: "未开启", value: 0 },
              { label: "已开启", value: 1 },
            ],
          },
          {
            label: "运动打卡",
            prop: "move",
            dicData: [
              { label: "未开启", value: 0 },
              { label: "已开启", value: 1 },
            ],
          },
          {
            label: "校准提醒",
            prop: "bp",
            dicData: [
              { label: "未开启", value: 0 },
              { label: "已开启", value: 1 },
            ],
          },
          {
            label: "数字档案完善",
            prop: "archive",
            dicData: [
              { label: "未开启", value: 0 },
              { label: "已开启", value: 1 },
            ],
          },
          {
            label: "服药提醒",
            prop: "drug",
            dicData: [
              { label: "未开启", value: 0 },
              { label: "已开启", value: 1 },
            ],
          },
          {
            label: "每周健康状态查看",
            prop: "weekHeal",
            dicData: [
              { label: "未开启", value: 0 },
              { label: "已开启", value: 1 },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.permission.health_userjk_add,
        viewBtn: this.permission.health_userjk_view,
        delBtn: this.permission.health_userjk_delete,
        editBtn: this.permission.health_userjk_edit,
      };
    },
    ids() {
      const ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  methods: {
    onLoad() {
      const wxUserId = this.$route.query.wxUserId;
      getUserJkDetail(wxUserId).then((res) => {
        this.info = res.data.userJk;
      });

      getMessagePush(wxUserId).then((res) => {
        this.data = res.data;
      });
    },

    back() {
      // this.$router.go(-1);
      this.$router.push({
        path: "/healthmanagement/onlinehealthmanagement",
      });
    },

    click(index) {
      let path = "";
      switch (index) {
        case 0:
          path = "/healthmanagement/healthdata";
          break;
        case 1:
          path = "/healthmanagement/digitalarchives";
          break;
        case 2:
          path = "/healthmanagement/healthplan";
          break;
        case 3:
          path = "/healthmanagement/cognitivebehavioral";
          break;
        case 4:
          path = "/healthmanagement/pushmessages";
          break;
      }
      const parameter = {
        wxUserId: this.wxUserid,
      };
      this.$router.push({
        path: path,
        query: parameter,
      });
    },
  },
};
</script>

<style scoped>
.card-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1vh;
  gap: 10px;
}

.card {
  background: rgba(243, 235, 235, 0.884) 2F5;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1vw;
  box-sizing: border-box;
}

.card01 {
  flex: 1;
  height: auto;
}

.card03 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-bottom: 2vh;
}

.healthButton {
  /* background-color: #ebedf0; */
  color: black;
  border: 0px solid #c1c3c5;
  border-bottom: none;
  font-size: 15px;
  border-radius: 0px;
  margin-bottom:2px;
}
.healthActive{
  border-bottom:3px solid #409EFF;
  color:#409EFF;
  font-weight: bold;
}
.headerClass{
    background-color: #409EFF !important;
    color:#FFF !important;
  }
</style>
